import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { mediaHelpers } from 'global/viewSettings/importing/mediaResults';
import { useCallback, useContext, useMemo } from 'react'
import { _sdm } from '../elements/dashboard/SportsDashboard';
import { SportsDistrictContext } from '../cnr/contexts/SportsDistrictContext';
import { newPropEditItem } from 'global/viewSettings/helpers/settingsHelpers';
import { gEnums } from 'global/enums/globalEnums';
import { _sportsFormProps, SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { _fetchModes } from '../elements/matches/MatchDataUpdate';
import { useGoogleSheets } from 'global/cnr/contexts/useHelpers/useGoogleSheets';
import { useFunctions } from 'global/cnr/contexts/useHelpers/useFunctions';

export const useGoogleSports = ({ currentMenuKey, sportsDataMode }) => {

  const parentContext = useContext(ParentContext);
  const { fn_cls } = parentContext ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { gls_scores } = district_data ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}

  const {
    latestSeason,
    links_score,
    teams_info,
    _sportsAbr,
  } = sportsSeason_state ?? {}

  const teams = teams_info?.teams

  const formProps = useMemo(() => {
    const _form_props = _sportsFormProps[sportsDataMode]
    const _appFormItems = {}
    if (_form_props) {
      Object.keys(_form_props).forEach(fp => {
        _appFormItems[fp] = newPropEditItem(fp, gEnums.formItemTypes.text, null, null, true)
      })
    }
    return _form_props
  }, [sportsDataMode])

  const linkValues = useMemo(() => {
    const _linkValues = {}
    switch (sportsDataMode) {
      case _sdm.district.updateDistrictSeasonScores:
        const xxx = gls_scores && currentMenuKey && gls_scores[currentMenuKey] ? gls_scores[currentMenuKey] : {}
        if (formProps) {
          Object.keys(formProps).forEach(fp => {
            _linkValues[fp] = xxx ? xxx[fp] : null
          })
        }
        break;
      default:
        if (formProps) {
          Object.keys(formProps).forEach(fp => {
            _linkValues[fp] = links_score ? links_score[fp] : null
          })
        }
    }
    return _linkValues
  }, [currentMenuKey])

  const getGsValues = (opts) => {
    let forMedia;
    let forPlayoffs
    let usePure;
    const { fetchMode } = opts
    const gsValues = _.clone(linkValues)
    gsValues.fetchMode = fetchMode
    switch (fetchMode) {
      case _fetchModes.results:
        gsValues.sheetName = linkValues.scoresSheet
        break;
      case _fetchModes.playoffResults:
        gsValues.sheetName = linkValues.playoffScoresSheet
        forPlayoffs = true
        break;
      case _fetchModes.resultsMedia:
        gsValues.sheetName = linkValues.scoresSheet
        forMedia = true
        break;
      case _fetchModes.playoffResultsMedia:
        forPlayoffs = true
        forMedia = true
        gsValues.sheetName = linkValues.playoffScoresSheet
        break;
      case _fetchModes.wpialResults:
        gsValues.googleSheetsId = '1ntWkPyKV9DYdwDcBDYshATj2HAfI-iAzYHHV48UYgN0'
        gsValues.sheetName = '3A Results'
        gsValues.ignoreStartCase = true
        usePure = true
        break;
      default:
      // nothing
    }
    return { gsValues, forMedia, forPlayoffs, usePure }
  }

  const getMedia_results = useCallback(
    async ({ year, dateGroupKeys, forPlayoffs, forRefresh, callback }) => {
      mediaHelpers.getMedia_results(
        dateGroupKeys,
        forPlayoffs,
        links_score,
        year,
        _sportsAbr,
        teams,
        forRefresh,
        callback
      )
    }, []);

  const handleGet_gsMatches = useCallback(
    async ({ opts, callback }) => {
      const { gsValues, forMedia, forPlayoffs, usePure } = getGsValues(opts)
      if (gsValues.sheetName) {
        const _latestSeason = opts?.latestSeason || latestSeason
        fn_cls.getGoogleSheetRange(gsValues || links_score, callback, null, gsValues?.ignoreStartCase, null, _latestSeason, forPlayoffs, forMedia, usePure)
      }
    }, []);

  const handleGet_gsRankings = useCallback(
    async ({ opts, callback }) => {
      const { gsValues } = getGsValues(opts)
      fn_cls.getGoogleSheetRange(gsValues ? gsValues : links_score, callback, null, null, null, latestSeason)
    }, []);

  const handleGet_gsRosters = useCallback(
    async ({ opts, callback }) => {
      const { gsValues } = getGsValues(opts)
      fn_cls.getGoogleSheetRange(gsValues ? gsValues : links_score, callback)
    }, []);

  return {
    getMedia_results,
    handleGet_gsMatches,
    handleGet_gsRankings,
    handleGet_gsRosters,
    linkValues,
  }

}
